import React, { useEffect, useState } from "react";
import api from "../lib/api";
import useSeo from "../hooks/useSeo";
import Reveal from "./Reveal";
import { sanitizeHtml } from "../lib/sanitize";

// Fetches a CMS page by slug, applies its SEO to the document, and renders
// any admin-editable HTML content as an extra section on built-in pages.
const CmsContent = ({ slug, fallbackTitle = "", showContent = true }) => {
  const [page, setPage] = useState(null);

  useEffect(() => {
    let active = true;
    api
      .get(`/pages/${slug}`)
      .then(({ data }) => active && setPage(data))
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [slug]);

  useSeo(page?.seo || {}, fallbackTitle);

  if (!showContent || !page || !page.content || page.content.trim() === "") {
    return null;
  }

  return (
    <section className="py-14 md:py-16 border-t border-white/5">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div
            className="prose-da text-gray-300 leading-relaxed space-y-4"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(page.content) }}
          />
        </Reveal>
      </div>
    </section>
  );
};

export default CmsContent;
